<template>
  <v-container fluid class="footer pt-2 pb-5">
    <v-container :class="$vuetify.breakpoint.smAndDown ? 'pl-0' : null">

      <v-layout>
        <v-flex xs6 md3>
          <v-layout column>

            <more-info></more-info>
            <feedback></feedback>

          </v-layout>
        </v-flex>
        <v-flex class="text-xs-right">
          <p class="foot-text">
            Toriliven seurannan tarjoaa
            <a href="https://www.taiste.com/fi" target="_blank">
              <img :src="require('@/assets/taiste-logo.svg')" class="taiste-logo">
            </a>
          </p>
        </v-flex>
      </v-layout>

    </v-container>
  </v-container>
</template>
<style lang="stylus" scoped>

  @import '~vuetify/src/stylus/settings/_variables.styl'

  .footer
    color white
    .taiste-logo
      max-width 80px
      display: inline-block
      margin-left: 10px
      margin-bottom: -18px
      @media $display-breakpoints.sm-and-up
        margin-bottom: -8px
        max-width 125px

    .foot-text
      font-family: 'Source Code Pro', monospace
      font-size 1em
      @media $display-breakpoints.sm-and-up
        font-size 1.4em

    .bottom-bar-hider
      padding-top 200px
      a
        color black !important

</style>
<script>

  import MoreInfo from './MoreInfo'
  import Feedback from './Feedback'

  export default {

    components: {
      MoreInfo,
      Feedback,
    },

  }

</script>